<template>
  <div class="bg-white p-4 sm:p-6 lg:p-8 rounded-lg shadow-lg w-full max-w-lg lg:max-w-6xl mb-8">
    <h2 class="text-lg sm:text-xl lg:text-2xl font-bold mb-4 text-gray-800">Manage Orders</h2>

    <!-- Align Add Button to the Right -->
    <div class="flex justify-end mb-4">
      <button class="px-4 py-2 rounded-lg bg-green hover:bg-green hover:text-gray-200 text-gray-100" @click="openAddOrderModal">
        Add
      </button>
    </div>

    <!-- Orders Table -->
    <table class="w-full text-left border-collapse">
      <thead>
        <tr>
          <th class="p-2 border-b-2">Date</th>
          <th class="p-2 border-b-2">Client</th>
          <th class="p-2 border-b-2">Total (FRw)</th>
          <th class="p-2 border-b-2">Status</th>
          <th class="p-2 border-b-2">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(order, index) in orders" :key="index" class="hover:bg-gray-100">
          <td class="p-2 border-b">{{ formatDate(order.createdAt) }}</td>
          <td class="p-2 border-b">{{ order?.client?.name }}</td>
          <td class="p-2 border-b">{{ order.totalAmount }}</td>
          <td class="p-2 border-b">{{ order.status }}</td>
          <td class="p-2 border-b">
            <button @click="viewOrder(order)" class="text-blue-500 hover:text-blue-700 focus:outline-none px-2">
              <i class="fas fa-eye"></i>
            </button>
            <button @click="dispatchOrder(order)" class="text-gray-500 hover:text-gray-700 focus:outline-none px-2">
              <i class="fa fa-paper-plane"></i>
            </button>
          </td>
        </tr>
        <tr v-if="orders.length === 0">
          <td colspan="5" class="text-center text-gray-500 p-4">No orders available.</td>
        </tr>
      </tbody>
    </table>

    <!-- Modals -->
    <AddOrderModal v-if="isAddOrderModalOpen" @closeModal="isAddOrderModalOpen = false" />
    <ViewOrderModal v-if="isViewOrderModalOpen" :order="selectedOrder" @closeModal="isViewOrderModalOpen = false" />
    <EditOrderModal v-if="isEditOrderModalOpen" :order="selectedOrder" @closeModal="isEditOrderModalOpen = false" />
    <DispatchOrderModal v-if="isDispathOrderModalOpen" :order="selectedOrder" @closeModal="isDispathOrderModalOpen = false" />
  </div>
</template>

<script>
import AddOrderModal from '@/views/orders/AddOrderModal.vue';
import ViewOrderModal from '@/views/orders/ViewOrderModal.vue';
import EditOrderModal from '@/views/orders/EditOrderModal.vue';
import DispatchOrderModal from './DispatchOrderModal.vue';
import { mapState, mapActions } from 'vuex';

export default {
  components: {
    AddOrderModal,
    ViewOrderModal,
    EditOrderModal,
    DispatchOrderModal
  },
  data() {
    return {
      isAddOrderModalOpen: false,
      isViewOrderModalOpen: false,
      isEditOrderModalOpen: false,
      isDispathOrderModalOpen : false,
      selectedOrder: null,
    };
  },
  async mounted() {
    await this.fetchOrders();
  },
  computed: {
    ...mapState('orders', {
      orders: state => state.orders,
    }),
  },
  methods: {
    ...mapActions('orders', { fetchOrders: 'fetchOrders' }),
    openAddOrderModal() {
      this.isAddOrderModalOpen = true;
    },
    dispatchOrder(order){
      this.selectedOrder = order;
      this.isDispathOrderModalOpen = true;
    },
    viewOrder(order) {
      this.selectedOrder = order;
      this.isViewOrderModalOpen = true;
    },
    editOrder(order) {
      this.selectedOrder = order;
      this.isEditOrderModalOpen = true;
    },
    deleteOrder(orderId) {
      this.$emit('deleteOrder', orderId);
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString();
    },
  },
};
</script>
